import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", fill: "current", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("rect", { x: 19, width: 4, height: 40, rx: 1 }), /* @__PURE__ */ React.createElement("rect", { x: 19, width: 4, height: 40, rx: 1, transform: "translate(40 0) rotate(90)" }));
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
